module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    staticStyle: {
      "background-color": "#ffffff"
    },
    attrs: {
      "id": "wrap"
    }
  }, [_c('div', {
    staticClass: "header-wrap-sticky",
    attrs: {
      "id": "pageNotStickyHeader"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "text-align": "left",
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "1em",
      "margin-right": "1em"
    }
  }, [_c('a', {
    staticClass: "col-xs-1 card-link",
    staticStyle: {
      "float": "left"
    },
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })]), _vm._v("   \r\n      "), _c('a', {
    staticClass: "col-xs-2 x-cta-btn card-link",
    staticStyle: {
      "float": "left",
      "width": "30px",
      "height": "40px",
      "text-align": "center"
    },
    attrs: {
      "href": '/' + _vm.order.order_business_username
    }
  }, [_c('p', {
    staticClass: "ltr-1"
  }, [_vm._v(_vm._s(_vm.order.order_user))])]), _vm._v(" "), _c('p', {
    staticClass: "col-xs-9"
  }, [_vm._v(_vm._s(_vm.order.order_user))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "pager",
    staticStyle: {
      "text-align": "left",
      "margin-top": "5em"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "text-align": "left",
      "margin-bottom": "5em"
    }
  }, [_c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), (_vm.menu_tab_inner_view['order_details']) ? _c('div', {}, [_c('div', {
    staticClass: "card-box card-02"
  }, [_c('h4', {
    staticStyle: {
      "font-weight": "800",
      "font-size": "22px",
      "line-height": "1.6"
    }
  }, [_vm._v("Order Details")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('p', [_c('b', [_vm._v("Order No: ")]), _vm._v(_vm._s(_vm.order.order_no))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Order Date: ")]), _vm._v(_vm._s(_vm.order.order_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("By: ")]), _vm._v(_vm._s(_vm.order.order_user))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("From: ")]), _vm._v(_vm._s(_vm.order.order_business))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Order Cost: ")]), _vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(_vm.order.order_items_total)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Delivery Charge: ")]), _vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(_vm.order.order_shipping_total)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Total to pay: ")]), _vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(_vm.order.order_total)))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right",
      "padding": "0.51em",
      "border-radius": "5px",
      "background-color": "#f7df2b",
      "color": "#000000"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.order.order_status))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-box card-02"
  }, [_c('h4', [_vm._v("Items Ordered")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "category-slide"
  }, [_c('ul', _vm._l((_vm.order.order_items), function(item, index) {
    return _c('li', {}, [(item.product_item_group_image && (item.product_item_group_image != '' && item.product_item_group_image != 'error')) ? _c('img', {
      staticStyle: {
        "width": "80px",
        "height": "100px",
        "border-radius": "8px"
      },
      attrs: {
        "src": _vm.img_product_url + item.product_item_group_image
      }
    }) : _c('img', {
      staticStyle: {
        "width": "80px",
        "height": "100px",
        "border-radius": "8px"
      },
      attrs: {
        "src": "/static/assets/images/dummy-image.png",
        "alt": ""
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('h6', [_vm._v(_vm._s(item.product_name))]), _vm._v(" "), _c('h6', {
      staticStyle: {
        "font-size": "18px",
        "text-align": "left"
      }
    }, [_vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(item.order_item_total)) + " "), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "14px"
      }
    }, [_c('b', [_vm._v("Quantity: ")]), _vm._v(_vm._s(item.order_item_quantity))])])])])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "card-box card-02"
  }, [_c('h4', [_vm._v("Delivery Details")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [(_vm.order.order_user_delivery_address != '') ? _c('p', [_vm._v(_vm._s(_vm.order.order_user_delivery_address))]) : _c('p', [_vm._v("Not set")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-box card-02"
  }, [_c('h4', [_vm._v("Order Contact Details")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('p', [_c('b', [_vm._v("Name: ")]), _vm._v(_vm._s(_vm.order.order_business))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Email Address: ")]), _vm._v(_vm._s(_vm.order.order_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Phone Number: ")]), _vm._v(_vm._s(_vm.order.order_user))])])]), _vm._v(" "), _c('div', {
    staticClass: "card-box card-02"
  }, [_c('h4', [_vm._v("Order Additional Information")]), _vm._v(" "), _c('hr'), _vm._v(" "), (Object.keys(_vm.order_additionals).length > 0) ? _c('div', _vm._l((_vm.order_additionals), function(detail, index) {
    return _c('div', [_c('p', [_c('b', [_vm._v(_vm._s(++index) + ". ")]), _vm._v(_vm._s(detail.order_additional_details))])])
  })) : _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No additional information")])])]) : _c('div', {}, [_c('div', {
    staticClass: "card-box card-02"
  }, [_c('h4', [_vm._v("Shopping on "), _c('b', [_vm._v(_vm._s(_vm.order.order_date))])]), _vm._v(" "), _c('p', [_vm._v("Status: "), _c('b', [_c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.order.order_status))])])]), _vm._v(" "), _c('p', [_vm._v("Deliver Items and Close this Shopping List Request")]), _vm._v(" "), _c('hr'), _vm._v(" "), (Object.keys(_vm.order_chart).length > 0) ? _c('div', [_c('div', [_c('div', {
    staticClass: "timeline"
  }, [_c('div', {
    staticClass: "container container-right"
  }, [_c('div', {
    staticClass: "card-box card-02"
  }, [_c('h5', [_vm._v("Shopping List "), _c('span', {
    staticStyle: {
      "color": "#ff0000",
      "float": "right"
    }
  }, [_vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(_vm.order.order_total)))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_vm._l((_vm.order.order_items), function(item, index) {
    return (index < 4) ? _c('p', {
      key: item.order_item_no
    }, [_vm._v("\r\n                        " + _vm._s(item.product_name) + " - ₦" + _vm._s(item.order_item_total.toFixed(2)) + "\r\n                      ")]) : _vm._e()
  }), _vm._v(" "), _c('a', {}, [_vm._v("see Items")])], 2), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('h5', [_vm._v("Delivery"), _c('span', {
    staticStyle: {
      "color": "#ff0000",
      "float": "right"
    }
  }, [_vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(_vm.order.order_shipping_total)))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [(_vm.order.order_user_delivery_address != '') ? _c('p', [_vm._v(_vm._s(_vm.order.order_user_delivery_address))]) : _c('p', [_vm._v("Not set")])])]), _vm._v(" "), (_vm.checkOrderChart('status', 35)) ? _c('div', [_c('hr'), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You confirmed these Items are available")])]) : _vm._e()])])])]), _vm._v(" "), _vm._l((_vm.order_chart), function(track) {
    return _c('div', [_c('div', {
      staticClass: "timeline"
    }, [(track.order_status_id == 20) ? _c('div', {
      staticClass: "container container-left"
    }, [_c('div', {
      staticClass: "card-box card-02"
    }, [_c('h5', [_vm._v("Proof of payment")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h6', [_vm._v("Please confirm payment")]), _vm._v(" "), _c('div', [(track.order_status_id == 20) ? _c('div', _vm._l((track.order_set_uploads), function(images) {
      return (images.data_image != '') ? _c('div', [(images.data_image) ? _c('img', {
        staticClass: "img-responsive",
        attrs: {
          "src": images.data_image
        }
      }) : _vm._e()]) : _vm._e()
    })) : _vm._e()]), _vm._v(" "), _c('div', [_c('hr'), _vm._v(" "), _c('button', {
      staticClass: "sp-button sp-button-lt",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.toggleSingleComponent('ConfirmPaymentUpdate')
        }
      }
    }, [_vm._v("Confirm Payment")]), _vm._v(" "), _c('div', {
      attrs: {
        "id": "ConfirmPaymentUpdate"
      }
    }, [_c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Confirm Order Payment ?")]), _vm._v(" "), _c('button', {
      staticClass: "sp-button sp-button-lt",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderCustomConfirmPaymentUpdate(_vm.order)
        }
      }
    }, [_vm._v("Yes, Confirm Payment")])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "timeline"
    }, [_c('div', {
      staticClass: "container container-right"
    }, [(track.order_status_id == 35) ? _c('div', {
      staticClass: "card-box card-02"
    }, [_c('h5', [_vm._v("How to Pay")]), _vm._v(" "), _c('hr'), _vm._v(" "), (track.order_set_bank_name != '') ? _c('h6', [_vm._v("Use the below account details to make payment")]) : _vm._e(), _vm._v(" "), (track.order_set_payment_link != '') ? _c('h6', [_vm._v("click the link below to make payment")]) : _vm._e(), _vm._v(" "), _c('div', [(track.order_status_id == 35) ? _c('div', [(track.order_set_bank_name != '') ? _c('div', [_c('p', [_c('b', [_vm._v("Bank Name: ")]), _vm._v(_vm._s(track.order_set_bank_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Bank Account Name: ")]), _vm._v(_vm._s(track.order_set_bank_account_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Bank Account No: ")]), _vm._v(_vm._s(track.order_set_bank_account_no))])]) : _vm._e(), _vm._v(" "), (_vm.order.order_payment_buyer_confirmation == 0) ? _c('div', [_c('div', [_c('hr'), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02",
      on: {
        "click": function($event) {
          _vm.toggleSingleComponent('setMakePayment')
        }
      }
    }, [_vm._v(_vm._s(track.order_status_cta))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": "setMakePayment"
      }
    }, [_c('div', {
      staticClass: "card"
    }, [_c('h4', [_vm._v("Have you made payment?")]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02",
      on: {
        "click": function($event) {
          _vm.setOrderCustomUpdates(_vm.order, 'custom_set_track_make_payment', 1)
        }
      }
    }, [_vm._v("YES\r\n                                "), (_vm.action_loading) ? _c('span', [_c('i', {
      staticClass: "fa fa-circle-o-notch"
    })]) : _vm._e()]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02 btn-danger",
      on: {
        "click": function($event) {
          _vm.toggleSingleComponent('setMakePayment')
        }
      }
    }, [_vm._v("NO")])])])]) : _vm._e()]) : _vm._e()])]) : _vm._e()])])])
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "card"
  }, [_c('hr'), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "prImagePreview"
    }
  }), _vm._v(" "), ((Object.keys(_vm.file_info).length == 0)) ? _c('div', [_c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn sp-button-02",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Upload Receipt")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChangeNewPhoto($event, 'transfer-receipt')
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.file_info[0]) ? _c('div', [_c('button', {
    staticClass: "btn btn-default wnf-button",
    staticStyle: {
      "width": "30vw",
      "margin-left": "0vw",
      "padding": "5px 3px"
    },
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.uploadFlexiPaymentReceipt(_vm.order, _vm.order.order_no, 'transferred')
      }
    }
  }, [_vm._v("Yes, Upload")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default wnf-button",
    staticStyle: {
      "width": "30vw",
      "margin-left": "0vw",
      "padding": "5px 3px",
      "background-color": "#f5f4e6",
      "color": "#000000"
    },
    on: {
      "click": function($event) {
        _vm.resetImageUpload()
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e()])])], 2) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "display": "none",
      "z-index": "10000",
      "width": "100%",
      "margin-left": "-0.11em",
      "border-left": "#ffffff solid"
    },
    attrs: {
      "id": "shareBox"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {}
    }
  }, [_c('span', {
    staticClass: "s-backdrop"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "width": "100%",
      "max-height": "75vh",
      "overflow": "scroll",
      "bottom": "0",
      "margin": "0 -1.2em",
      "background": "none",
      "z-index": "10000"
    }
  }, [_c('div', {
    staticClass: "z-box",
    staticStyle: {
      "width": "100%",
      "padding": "0.1em",
      "border-radius": "35px 35px 0px 0px"
    }
  }, [_c('div', {
    staticStyle: {
      "min-height": "200px",
      "padding": "2em",
      "margin-bottom": "5.8em",
      "border-bottom": "#eee solid",
      "text-align": "left"
    }
  }, [_c('div', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "display": "block"
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('shareBox')
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right",
      "padding": "1em"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 1em",
      "margin-bottom": "5em"
    }
  }, [(_vm.set_view_box == '') ? _c('div', {
    staticClass: "row"
  }, [_c('h3', [_vm._v("Give a star rating")]), _vm._v(" "), _vm._l((5), function(star) {
    return _c('div', {
      staticStyle: {
        "display": "inline-block"
      }
    }, [_c('a', {
      staticClass: "card-link",
      staticStyle: {
        "margin-right": "2em",
        "font-size": "28px",
        "line-height": "0.4",
        "text-decoration": "none"
      },
      on: {
        "click": function($event) {
          _vm.setRate(_vm.order.order_items[0], star)
        }
      }
    }, [_c('span', [_c('i', {
      staticClass: "fa fa-star-o",
      attrs: {
        "id": 'rate-' + star
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-star",
      staticStyle: {
        "display": "none",
        "color": "#f7df2b"
      },
      attrs: {
        "id": 'rated-' + star
      }
    })]), _vm._v(" "), _c('p', {
      staticStyle: {
        "margin-top": "0.2em",
        "color": "#000000",
        "font-size": "12px",
        "font-weight": "600"
      }
    }, [(star == 1) ? _c('span', [_vm._v("Bad")]) : _vm._e(), _vm._v(" "), (star == 2) ? _c('span', [_vm._v("Not Bad")]) : _vm._e(), _vm._v(" "), (star == 3) ? _c('span', [_vm._v("Okay")]) : _vm._e(), _vm._v(" "), (star == 4) ? _c('span', [_vm._v("Good")]) : _vm._e(), _vm._v(" "), (star == 5) ? _c('span', [_vm._v("Great")]) : _vm._e()])])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('a', {
    staticClass: "card-link x-cta-btn",
    on: {
      "click": function($event) {
        _vm.submitReview()
      }
    }
  }, [_vm._v("Send\r\n                    "), (_vm.action_loading) ? _c('span', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })]) : _vm._e()])])], 2) : _vm._e(), _vm._v(" "), (_vm.set_view_box == 'setDeliveryLocation') ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "setDeliveryLocation"
    }
  }, [(Object.keys(_vm.business_delivery_locations).length > 0) ? _c('div', [_vm._m(1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "-1em"
    }
  }, [_vm._l((_vm.business_delivery_locations), function(location, index) {
    return _c('div', [_c('p', [_c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.set_order_delivery_location),
        expression: "set_order_delivery_location"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": location.business_delivery_option_id,
        "checked": _vm._q(_vm.set_order_delivery_location, location.business_delivery_option_id)
      },
      on: {
        "click": function($event) {
          _vm.setOrderDeliveryLocation(location)
        },
        "__c": function($event) {
          _vm.set_order_delivery_location = location.business_delivery_option_id
        }
      }
    })]), _vm._v("\r\n                        " + _vm._s(location.business_delivery_state) + " - " + _vm._s(location.business_delivery_option) + " - " + _vm._s(location.business_delivery_option_price) + "\r\n                      ")])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 2)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.set_view_box == 'setContactDetails') ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "setContactDetails"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h3', [_vm._v("Order Contact Details")]), _vm._v(" "), (_vm.user.user_id && (_vm.user.user_id > 0)) ? _c('div', [_c('p', [_vm._v("Review contact details")]), _vm._v(" "), _c('div', [_c('p', [_c('b', [_vm._v("Name: ")]), _vm._v(_vm._s(_vm.user.user_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Email: ")]), _vm._v(_vm._s(_vm.user.user_email))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Phone: ")]), _vm._v(_vm._s(_vm.user.user_phone))]), _c('hr'), _vm._v(" "), _c('p', [_c('b', [_vm._v("Delivety Address: ")]), _vm._v(_vm._s(_vm.user.user_order_delivey_address))]), _vm._v(" "), _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("Reset")])])]), _vm._v(" "), ((_vm.set_payment_mode == 1) && (_vm.user.user_email == '')) ? _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_email),
      expression: "user.user_email"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.user.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_email = $event.target.value
      }
    }
  })]) : _vm._e()]) : _c('div', [(_vm.menu_tab_inner_view['showUserDetails']) ? _c('div', [_c('p', [_c('b', [_vm._v("Name: ")]), _vm._v(_vm._s(_vm.user.user_name))]), _c('hr'), _vm._v(" "), _c('p', [_c('b', [_vm._v("Email: ")]), _vm._v(_vm._s(_vm.user.user_email))]), _c('hr'), _vm._v(" "), _c('p', [_c('b', [_vm._v("Phone: ")]), _vm._v(_vm._s(_vm.user.user_phone))]), _c('hr'), _vm._v(" "), _c('p', [_c('b', [_vm._v("Delivety Address: ")]), _vm._v(_vm._s(_vm.user.user_order_delivey_address))]), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("Reset")])])]) : _c('div', [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_name),
      expression: "user.user_name"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.user.user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_email),
      expression: "user.user_email"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.user.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_phone),
      expression: "user.user_phone"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.user.user_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-top-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('showUserDetails')
      }
    }
  }, [_vm._v("Ok")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.set_view_box == 'setPaymentOptions') ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "setPaymentOptions"
    }
  }, [(_vm.menu_tab_inner_view['showOrderPaymentConfirmation']) ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "setPaymentSuccess"
    }
  }, [_c('p', [_vm._v("Payment Made")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('a', {
    staticClass: "x-cta-btn card-link",
    attrs: {
      "href": '/placed/order/' + _vm.order.order_no
    }
  }, [_vm._v("View Order")])]) : _c('div', [_vm._m(2), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "-1em"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h3', [_vm._v("Payment Method")]), _vm._v(" "), _c('div', [_c('p', [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.set_payment_mode),
      expression: "set_payment_mode"
    }],
    attrs: {
      "type": "radio",
      "value": "4"
    },
    domProps: {
      "checked": _vm._q(_vm.set_payment_mode, "4")
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('payBank')
      },
      "__c": function($event) {
        _vm.set_payment_mode = "4"
      }
    }
  })]), _vm._v("\r\n                        Pay to Bank")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "payBank"
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', [_c('p', [_c('b', [_vm._v("Bank: ")]), _vm._v(_vm._s(_vm.sellpoint.business_bank_details.bank_name)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Account Name: ")]), _vm._v(_vm._s(_vm.sellpoint.business_bank_details.bank_account_name)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Account Number: ")]), _vm._v(_vm._s(_vm.sellpoint.business_bank_details.bank_account_number))])])])]), _vm._v(" "), _c('div', [_c('p', [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.set_payment_mode),
      expression: "set_payment_mode"
    }],
    attrs: {
      "type": "radio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.set_payment_mode, "1")
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('payDirect')
      },
      "__c": function($event) {
        _vm.set_payment_mode = "1"
      }
    }
  })]), _vm._v("\r\n                        Pay to Direct")]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', [(_vm.data_processing_messages.mode_err) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_messages.mode_err))]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "x-cta-btn",
    on: {
      "click": function($event) {
        _vm.setMakeOrder(_vm.set_payment_mode)
      }
    }
  }, [_vm._v("Place Order")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 1em",
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "card-top-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "padding": "3px 3px",
      "line-height": "0.2"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setViewBox('setDeliveryLocation')
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "38px"
    }
  }, [_vm._v("-")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding": "0 0.61em"
    }
  }, [_vm._v("900")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "padding": "3px 3px",
      "line-height": "0.6"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setViewBox('setDeliveryLocation')
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "28px"
    }
  }, [_vm._v("+")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), (_vm.product.product_addons && (_vm.product.product_addons.length > 0)) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "card-top-right",
    staticStyle: {
      "float": "right"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "category-slide",
    staticStyle: {
      "margin-top": "0"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('setOptions');
        _vm.set_view_box = 'setAddons'
      }
    }
  }, [_c('ul', {
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, _vm._l((_vm.product.product_addons), function(product, index) {
    return _c('li', [_c('div', {
      staticClass: "card",
      staticStyle: {
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "card-avatar-circle",
      staticStyle: {
        "width": "50px",
        "height": "45px"
      }
    }, [(product.product_images && (Object.keys(product.product_images).length > 0)) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-col-details",
      staticStyle: {
        "display": "none",
        "padding": "3px",
        "text-align": "center"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(product.product_name) + " "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "sm-x"
    }, [_vm._v("₦‎" + _vm._s(product.product_items[0].product_item_price_f))])]), _vm._v(" "), (_vm.checkOrderProductAddons(product)) ? _c('div', [_c('input', {
      attrs: {
        "checked": "true",
        "type": "checkbox"
      },
      on: {
        "click": function($event) {
          _vm.setOrderProductAddons(product)
        }
      }
    }), _vm._v(" Added\r\n                            ")]) : _c('div', [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      on: {
        "click": function($event) {
          _vm.setOrderProductAddons(product)
        }
      }
    }), _vm._v(" Add")])])])])
  }))])])]) : _c('div', {
    staticStyle: {
      "height": "0em"
    }
  }), _vm._v(" "), (Object.keys(_vm.business_delivery_locations).length > 0) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "card-top-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "background-color": "#f5e61d"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setViewBox('setDeliveryLocation')
      }
    }
  }, [_vm._v("select")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none",
      "position": "fixed",
      "border": "none",
      "width": "100%",
      "bottom": "0",
      "margin": "0",
      "padding-top": "1.2em",
      "padding-right": "0",
      "background": "#ffffff",
      "z-index": "10000"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "block",
      "width": "100%",
      "height": "auto",
      "background-color": "rgba(0, 0, 0, 0)"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "display": "none",
      "z-index": "10000",
      "width": "100%"
    },
    attrs: {
      "id": "shareBoxtt"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {}
    }
  }, [_c('span', {
    staticClass: "s-backdrop",
    staticStyle: {
      "bottom": "5em"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "max-height": "75vh",
      "overflow": "scroll",
      "bottom": "5em",
      "margin": "0 -1.2em",
      "background": "none",
      "z-index": "10000"
    }
  }, [_c('div', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "display": "block"
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('shareBox')
      }
    }
  }, [_vm._m(8), _vm._v(" "), _c('span', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right",
      "padding": "1em"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 1em",
      "margin-bottom": "5em"
    }
  }, [(_vm.set_view_box == '') ? _c('div', {
    staticClass: "row"
  }) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "border-top": "#f5f3f3 solid"
    }
  }, [_c('div', {
    staticClass: "row-ic-02",
    staticStyle: {
      "margin-top": "0.01em"
    }
  }, [_c('div', {
    staticClass: "col-xs-6",
    staticStyle: {
      "padding-left": "0",
      "background-color": "#f7df2b"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._m(9), _c('span', {
    staticClass: "ct-dsc"
  }, [_vm._v("Confirm Purchase")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6",
    staticStyle: {
      "background-color": "#fae570"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('order_details')
      }
    }
  }, [_vm._m(10), _c('span', {
    staticClass: "ct-dsc",
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v("Shopping List")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "-1em",
      "margin-bottom": "-0.3em",
      "padding": "0",
      "font-size": "2em"
    }
  }, [_c('span', [_vm._v("___")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-left",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-shopping-bag",
    staticStyle: {
      "font-size": "3em"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-right",
    staticStyle: {
      "margin-top": "-1.4em"
    }
  }, [_c('h3', [_vm._v("Delivery Locations")]), _vm._v(" "), _c('p', [_vm._v("set where you want this order delivered to")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "0.2em"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-left",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-shopping-bag",
    staticStyle: {
      "font-size": "3em"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-right",
    staticStyle: {
      "margin-top": "-1.4em"
    }
  }, [_c('h3', [_vm._v("Payment")]), _vm._v(" "), _c('p', [_vm._v("set where you want this order delivered to")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "0.2em"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Send to:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "payDirect"
    }
  }, [_c('p', [_vm._v("Pay with your Credit/ATM card")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('h5', [_vm._v("Quantity")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('h5', {
    staticStyle: {
      "line-height": "1.2"
    }
  }, [_vm._v("Add to Order"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-top": "0.05em",
      "font-size": "13px"
    }
  }, [_vm._v("items you should buy with this order")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('h5', [_vm._v("Delivery Location")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "-1em",
      "margin-bottom": "-0.3em",
      "padding": "0",
      "font-size": "2em"
    }
  }, [_c('span', [_vm._v("___")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "margin": "0 1em",
      "border-radius": "38%",
      "color": "#000000",
      "padding": "0.22em 0.31em"
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-right",
    staticStyle: {
      "font-size": "1.6em"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "margin": "0 1em",
      "border-radius": "38%",
      "color": "#000000",
      "padding": "0.22em 0.31em"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    staticStyle: {
      "font-size": "1.6em"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-332b5c7e"}!./src/pages/ManageShop/template.html
// module id = 566
// module chunks = 0